import {rawRenderingLib} from '@wallaby-ui/core';

import styles from 'src/js/common/components/formatters/MarkerListFormatter.less';
import baseListFormatterItemParams from 'src/js/lib/raw_rendering/base_list_formatter_item_params';

/**
 * Returns raw Html version of MarkerListFormatterItem component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function markerListFormatterItemRenderer(params, services = {}) {
  const {label, item, title} = baseListFormatterItemParams(params, services);

  const spanElem = document.createElement('span');
  spanElem.className = styles.dlMarker;
  spanElem.title = title;
  rawRenderingLib.RawRenderingService.setNodeStyle(spanElem, item.style);

  const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
    showHtml: true,
    text: label,
  });
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, textElem);

  return spanElem.outerHTML;
}
